import React from "react";

// Pilulka. Barva něco znamená: šedá je jen údaj, fialová značkový štítek,
// zelená že je hotovo, žlutá varuje, rudá je chyba (zadání 4.7 bod 17).
// Tóny zůstávají pojmenované stejně jako dřív, aby se nemuselo sáhnout do
// stránek, které je předávají.
const tones = {
  slate: "bg-slate-100 text-slate-700",
  green: "bg-emerald-100 text-emerald-800",
  red: "bg-rose-100 text-rose-800",
  amber: "bg-amber-100 text-amber-900",
  blue: "bg-sky-100 text-sky-900",
  purple: "bg-brand-light text-brand-deep",
  brand: "bg-brand-light text-brand-deep",
  // Žlutá znamená "tohle čeká na tebe", ne obyčejné varování.
  ceka: "bg-brand-gold text-brand-dark",
  outline: "border border-brand/30 text-brand-deep",
};

export default function Pill({ tone = "slate", className = "", children, ...rest }) {
  return (
    <span
      {...rest}
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${tones[tone] || tones.slate} ${className}`}
    >
      {children}
    </span>
  );
}
